<template>
  <div :class="classes()">
    <ul :class="`${el}__list`">
      <li v-for="item in items" :key="item.text" :class="`${el}__listItem`">
        <Link
          :to="item.link"
          :external="item.external"
          :class="`${el}__link`"
          weight="regular"
          no-underline
        >
          {{ item.text }}
        </Link>
      </li>
    </ul>
  </div>
</template>

<script>
import Link from '@/objects/Link';

import items from '@/content/generals/navigation';

export default {
  name: 'Footer',
  components: { Link },
  data() {
    return {
      el: 'c-footer',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
      items,
    };
  },
};
</script>
